<div class="import-container">
  <div class="page-header" *ngIf="!eingebettet">
    <h1 class="page-title">
      <mat-icon class="title-icon">upload_file</mat-icon>
      Liste importieren
    </h1>
    <button mat-button (click)="cancel()">
      <mat-icon>arrow_back</mat-icon>
      Zurück
    </button>
  </div>

  <!-- Schritt 1: Datei -->
  <mat-card class="step-card" data-wizard-target="import-datei" *ngIf="!eingebettet">
    <mat-card-content>
      <div class="step-head">
        <span class="step-number">1</span>
        <span class="step-title">Excel-Datei wählen</span>
      </div>

      <div class="file-row">
        <button mat-stroked-button color="primary" (click)="fileInput.click()" [disabled]="isPreviewing">
          <mat-icon>attach_file</mat-icon>
          Datei auswählen
        </button>
        <input #fileInput type="file" accept=".xlsx,.xlsm,.xls" hidden (change)="onFileSelected($event)">

        <span class="file-name" *ngIf="file">{{ file.name }}</span>
        <span class="file-hint" *ngIf="!file">Unterstützt werden .xlsx, .xlsm und .xls</span>
      </div>

      <div class="loading-inline" *ngIf="isPreviewing">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Datei wird gelesen und Struktur erkannt…</span>
      </div>
    </mat-card-content>
  </mat-card>


  <!-- LADEANZEIGE FÜR KI-ANALYSE -->
  <div class="ki-loading" *ngIf="eingebettet && isPreviewing">

    <mat-icon class="ki-loading-icon">
      auto_awesome
    </mat-icon>

    <h3>Excel-Datei wird analysiert</h3>

    <p>
      Die Datei wird eingelesen, der Aufbau erkannt
      und die KI-gestützte Importvorschau vorbereitet.
    </p>

    <mat-progress-bar mode="indeterminate">
    </mat-progress-bar>

    <span class="ki-loading-hinweis">
      Je nach Dateigröße kann die Analyse etwas dauern.
    </span>

  </div>


  <mat-card class="error-card" *ngIf="errorMessage">
    <mat-card-content>
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
      <!-- Eingebettet gibt es keinen Dateiknopf – die Analyse wird hier neu gestartet. -->
      <button mat-stroked-button type="button" *ngIf="eingebettet && !isPreviewing" (click)="erneutAnalysieren()">
        <mat-icon>refresh</mat-icon>
        Erneut versuchen
      </button>
    </mat-card-content>
  </mat-card>

  <!-- Hinweis, wenn die Erkennung nicht griff -->
  <mat-card class="ai-hint-card" *ngIf="aiMessage && !analysis">
    <mat-card-content>
      <mat-icon>info_outline</mat-icon>
      <span>{{ aiMessage }}</span>
    </mat-card-content>
  </mat-card>


  <!-- =================================================================
       ERKENNUNG – KOMPAKT

       Sechs Zeilen. Was gefunden wurde, soll man lesen können, ohne es
       zu bearbeiten. Alles Korrigierbare steckt hinter „Erkennung
       bearbeiten“ – dieselben Felder wie bisher, nur nicht im Weg.
       ================================================================= -->

  <mat-card class="step-card" *ngIf="analysis" data-wizard-target="import-erkennung">
    <mat-card-content>

      <div class="step-head">
        <span class="step-number">2</span>
        <span class="step-title">Erkannte Struktur</span>

        <button mat-stroked-button type="button" class="kopf-aktion" (click)="erkennungBearbeitenUmschalten()">
          <mat-icon>{{ erkennungBearbeiten ? 'expand_less' : 'tune' }}</mat-icon>
          {{ erkennungBearbeiten ? 'Bearbeitung schließen' : 'Erkennung bearbeiten' }}
        </button>
      </div>

      <!-- Die Zusammenfassung -->
      <ul class="erkennung-kompakt">
        <li>
          <mat-icon class="haken">check</mat-icon>
          <span>{{ listenTypText }}</span>
          <span class="kompakt-conf" *ngIf="listenTypProzent < 70">
            nur {{ listenTypProzent }} % sicher
          </span>
        </li>
        <li>
          <mat-icon class="haken">check</mat-icon>
          <span>Arbeitsblatt: {{ analysis.sheetName }}</span>
        </li>
        <li>
          <mat-icon class="haken">check</mat-icon>
          <span>Kennzeichnung: {{ kennzeichnungAnzeige }}</span>
          <span class="kompakt-conf" *ngIf="kennzeichnungProzent < 70">
            nur {{ kennzeichnungProzent }} % sicher
          </span>
        </li>
        <li>
          <mat-icon class="haken">check</mat-icon>
          <span>{{ kopfbereichText }}</span>
        </li>
        <li>
          <mat-icon class="haken">check</mat-icon>
          <span>{{ zugeordneteFelder }} Standardfelder erkannt</span>
        </li>
        <li>
          <mat-icon class="haken">check</mat-icon>
          <span>{{ importierteSpalten }} Excel-Spalten erkannt</span>
        </li>
        <li>
          <mat-icon class="haken">check</mat-icon>
          <span>{{ gewaehlteSpalten }} werden importiert</span>
          <span class="kompakt-conf" *ngIf="ausgeschlosseneSpalten > 0">
            {{ ausgeschlosseneSpalten }} ausgeschlossen
          </span>
        </li>
      </ul>

      <div class="ai-warnungen" *ngIf="erkennungHatHinweise && !erkennungBearbeiten">
        <div class="warnung-zeile" *ngFor="let w of analysis.warnungen">
          <mat-icon inline>report_problem</mat-icon>
          <span>{{ w }}</span>
        </div>
        <div class="warnung-zeile" *ngIf="unsichereSpalten > 0">
          <mat-icon inline>report_problem</mat-icon>
          <span>
            {{ unsichereSpalten }} Spalte{{ unsichereSpalten === 1 ? '' : 'n' }}
            wurde{{ unsichereSpalten === 1 ? '' : 'n' }} nur unsicher zugeordnet –
            unter „Spalten anpassen“ nachsehen.
          </span>
        </div>
        <div class="warnung-zeile" *ngIf="fremdeFelder.length > 0">
          <mat-icon inline>report_problem</mat-icon>
          <span>
            {{ fremdeFelder.length }} Zuordnung(en) außerhalb des Katalogs:
            {{ fremdeFelder.join(', ') }}
          </span>
        </div>
      </div>


      <!-- ── Bearbeiten ── -->

      <div class="erkennung-bearbeiten" *ngIf="erkennungBearbeiten">

        <p class="ai-reasoning" *ngIf="analysis.reasoning">
          <mat-icon inline>auto_awesome</mat-icon>
          {{ analysis.reasoning }}
        </p>

        <!-- Mehrere auswertbare Blätter: welches soll es sein? -->
        <div class="blatt-block" *ngIf="zeigeBlattauswahl">
          <p class="step-hint">
            Die Datei enthält mehrere Arbeitsblätter mit auswertbaren Listen.
            Ein Wechsel übernimmt die komplette Beurteilung dieses Blatts.
          </p>

          <div class="blatt-liste">
            <button type="button" class="blatt-karte" *ngFor="let blatt of relevanteBlaetter"
              [class.blatt-gewaehlt]="istGewaehltesBlatt(blatt)" (click)="waehleBlatt(blatt)">

              <mat-icon class="blatt-icon">
                {{ istGewaehltesBlatt(blatt) ? 'radio_button_checked' : 'radio_button_unchecked' }}
              </mat-icon>

              <span class="blatt-text">
                <span class="blatt-name">{{ blatt.sheetName }}</span>
                <span class="blatt-meta">
                  {{ blattTypText(blatt) }}
                  · {{ blatt.columns.length }} Spalten
                  · {{ blattZeilen(blatt) }} Zeilen
                  · Sicherheit {{ (blatt.listTypeConfidence * 100) | number:'1.0-0' }} %
                </span>
              </span>
            </button>
          </div>

          <details class="blatt-details" *ngIf="gefundeneBlaetter.length > relevanteBlaetter.length">
            <summary>Nicht importierbare Arbeitsblätter anzeigen</summary>
            <ul class="blatt-verworfen">
              <li *ngFor="let blatt of gefundeneBlaetter">
                <ng-container *ngIf="!blatt.relevant">
                  <strong>{{ blatt.sheetName }}</strong>
                  <span *ngIf="blatt.reasoning"> – {{ blatt.reasoning }}</span>
                </ng-container>
              </li>
            </ul>
          </details>
        </div>

        <!-- Kopfdaten der Erkennung, alle korrigierbar -->
        <div class="erkennung-uebersicht">
          <div class="erkennung-kachel">
            <span class="kachel-label">Listentyp</span>
            <mat-form-field appearance="outline" class="kachel-feld">
              <mat-select [(ngModel)]="analysis.listType" (ngModelChange)="onListenTypGeaendert()">
                <mat-option *ngFor="let t of listenTypen" [value]="t.wert">{{ t.text }}</mat-option>
              </mat-select>
            </mat-form-field>
            <span class="kachel-conf" [class.conf-niedrig]="listenTypProzent < 70">
              erkannt mit {{ listenTypProzent }} %
            </span>
          </div>

          <div class="erkennung-kachel">
            <span class="kachel-label">Kennzeichnung</span>
            <mat-form-field appearance="outline" class="kachel-feld">
              <mat-select [(ngModel)]="analysis.identifierType" (selectionChange)="vorschauAktualisieren()">
                <mat-option *ngFor="let a of kennzeichnungsArten" [value]="a.wert">{{ a.text }}</mat-option>
              </mat-select>
            </mat-form-field>
            <span class="kachel-conf" [class.conf-niedrig]="kennzeichnungProzent < 70">
              erkannt mit {{ kennzeichnungProzent }} %
            </span>
          </div>

          <div class="erkennung-kachel">
            <span class="kachel-label">Arbeitsblatt</span>
            <mat-form-field appearance="outline" class="kachel-feld">
              <mat-select [(ngModel)]="analysis.sheetName" (selectionChange)="vorschauAktualisieren()">
                <mat-option *ngFor="let s of preview?.sheets" [value]="s.name">{{ s.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="erkennung-kachel">
            <span class="kachel-label">Kopf ab Zeile</span>
            <mat-form-field appearance="outline" class="kachel-feld">
              <input matInput type="number" min="1" [(ngModel)]="analysis.headerStartRow"
                (ngModelChange)="vorschauAktualisieren()">
            </mat-form-field>
          </div>

          <div class="erkennung-kachel">
            <span class="kachel-label">Kopf bis Zeile</span>
            <mat-form-field appearance="outline" class="kachel-feld">
              <input matInput type="number" min="1" [(ngModel)]="analysis.headerEndRow"
                (ngModelChange)="vorschauAktualisieren()">
            </mat-form-field>
          </div>

          <div class="erkennung-kachel">
            <span class="kachel-label">Daten ab Zeile</span>
            <mat-form-field appearance="outline" class="kachel-feld">
              <input matInput type="number" min="2" [(ngModel)]="analysis.dataStartRow"
                (ngModelChange)="vorschauAktualisieren()">
            </mat-form-field>
            <span class="kachel-conf">muss unter dem Kopf liegen</span>
          </div>
        </div>

        <div class="ai-warnungen" *ngIf="analysis.warnungen && analysis.warnungen.length > 0">
          <div class="warnung-zeile" *ngFor="let w of analysis.warnungen">
            <mat-icon inline>report_problem</mat-icon>
            <span>{{ w }}</span>
          </div>
        </div>

        <div class="erkennung-fuss">
          <span class="step-hint">
            Die Bedeutung der einzelnen Spalten steht unter „Spalten anpassen“
            bei der Vorschau.
          </span>

          <button mat-stroked-button type="button" class="discard-btn" (click)="discardAnalysis()">
            <mat-icon>undo</mat-icon>
            Erkennung verwerfen und manuell wählen
          </button>
        </div>
      </div>

    </mat-card-content>
  </mat-card>


  <!-- Manueller Weg: Blatt und Kopfzeile -->
  <mat-card class="step-card" *ngIf="preview && !analysis" data-wizard-target="import-erkennung">
    <mat-card-content>
      <div class="step-head">
        <span class="step-number">2</span>
        <span class="step-title">Arbeitsblatt und Kopfzeile prüfen</span>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>Arbeitsblatt</mat-label>
          <mat-select [ngModel]="selectedSheetName" (ngModelChange)="selectSheet($event)">
            <mat-option *ngFor="let sheet of preview.sheets" [value]="sheet.name">
              {{ sheet.name }}
              <span class="option-sub" *ngIf="sheet.dataRowCount > 0">({{ sheet.dataRowCount }} Zeilen)</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="selectedSheet">
          <mat-label>Zeile mit den Spaltenüberschriften</mat-label>
          <mat-select [(ngModel)]="headerRowNumber" (selectionChange)="vorschauAktualisieren()">
            <mat-option *ngFor="let row of selectedSheet.firstRows" [value]="row.rowNumber">
              Zeile {{ row.rowNumber }} – {{ row.cells.join(' | ') | slice:0:70 }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <p class="empty-sheet" *ngIf="selectedSheet && selectedSheet.firstRows.length === 0">
        Dieses Arbeitsblatt ist leer.
      </p>

      <div class="preview-wrapper" *ngIf="columns.length > 0">
        <div class="preview-label">
          Vorschau – {{ columns.length }} Spalten<span *ngIf="selectedSheet">,
            {{ selectedSheet.dataRowCount }} Datenzeilen insgesamt</span>
        </div>
        <div class="preview-scroll">
          <table class="preview-table">
            <thead>
              <tr>
                <th class="row-col">Zeile</th>
                <th *ngFor="let col of columns">{{ col || '—' }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of dataRows; let i = index">
                <td class="row-col">{{ headerRowNumber + i + 1 }}</td>
                <td *ngFor="let col of columns; let c = index">{{ row[c] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-card-content>
  </mat-card>


  <!-- =================================================================
       ANLAGENTEILE – KOMPAKT

       Eine Zeile sagt, was gefunden wurde. Wer prüfen will, klappt auf:
       Spaltenwahl, Klartexte und Regeln stehen unverändert dahinter.
       ================================================================= -->

  <mat-card class="step-card" *ngIf="analysis" data-wizard-target="import-anlagenteile">
    <mat-card-content>

      <div class="step-head">
        <span class="step-number">3</span>
        <span class="step-title">Anlagenteile</span>

        <button mat-stroked-button type="button" class="kopf-aktion" (click)="anlagenteileBearbeitenUmschalten()">
          <mat-icon>{{ anlagenteileBearbeiten ? 'expand_less' : 'tune' }}</mat-icon>
          {{ anlagenteileBearbeiten ? 'Prüfung schließen' : 'Zuordnungen prüfen' }}
        </button>
      </div>

      <p class="kompakt-zeile">
        <ng-container *ngIf="anlagenteilSpalte !== null">
          <mat-icon class="haken">check</mat-icon>
          <span>
            „{{ anlagenteilSpaltenAnzeige }}“ erkannt
            <ng-container *ngIf="anlagenteileAnzahl > 0">
              · {{ anlagenteileAnzahl }} Anlagenteil{{ anlagenteileAnzahl === 1 ? '' : 'e' }}
            </ng-container>
            <ng-container *ngIf="aktiveAnlagenteilRegelnAnzahl > 0">
              · {{ aktiveAnlagenteilRegelnAnzahl }} Regel{{ aktiveAnlagenteilRegelnAnzahl === 1 ? '' : 'n' }}
            </ng-container>
          </span>
        </ng-container>

        <ng-container *ngIf="anlagenteilSpalte === null">
          <mat-icon class="haken haken-leer">remove</mat-icon>
          <span>
            Keine Anlagenteil-Spalte erkannt.
            <ng-container *ngIf="anlagenteileAnzahl > 0">
              {{ anlagenteileAnzahl }} Anlagenteil{{ anlagenteileAnzahl === 1 ? '' : 'e' }} aus Regeln.
            </ng-container>
            <ng-container *ngIf="anlagenteileAnzahl === 0">
              Der Import funktioniert auch ohne.
            </ng-container>
          </span>
        </ng-container>
      </p>


      <div class="kompakt-inhalt" *ngIf="anlagenteileBearbeiten">

        <p class="step-hint">
          Anlagenteile gruppieren die Messstellen für Suche, Filter und den
          Projektfortschritt – zum Beispiel „Absackung“ oder „Kessel“. Sie
          entstehen erst beim Import, und nur die, die auch getroffen werden.
        </p>

        <div class="regel-zeile">
          <mat-form-field appearance="outline" class="regel-feld">
            <mat-label>Anlagenteil aus einer Spalte übernehmen</mat-label>
            <mat-select [(ngModel)]="anlagenteilSpalte" (selectionChange)="vorschauAktualisieren()">
              <mat-option [value]="null">— keine Spalte —</mat-option>
              <mat-option *ngFor="let s of dateiSpalten" [value]="s.columnIndex">
                {{ s.originalName }}
              </mat-option>
            </mat-select>
            <mat-hint>
              Führt die Datei bereits eine Spalte wie „Anlagenbereich“, werden
              deren Werte zu Anlagenteilen.
            </mat-hint>
          </mat-form-field>
        </div>

        <!--
          Die Werte der gewählten Spalte, jeder mit einem Feld für Klartext.
          "UKR12" ist technisch richtig und für den Monteur nichtssagend.

          Der Excel-Wert wird dabei NICHT verändert: er bleibt in der Zeile
          stehen und wird am Anlagenteil als Herkunft vermerkt. Bleibt das Feld
          leer, gilt weiterhin der Excel-Wert selbst.
        -->
        <div class="anlagenteil-werte" *ngIf="anlagenteilSpalte !== null && anlagenteilWerte.length > 0">

          <div class="anlagenteil-werte-kopf">
            <span class="anlagenteil-werte-titel">
              Gefundene Werte
              <span class="anlagenteil-werte-anzahl">{{ anlagenteilWerte.length }}</span>
            </span>

            <button mat-button type="button" *ngIf="hatAnlagenteilNamen" (click)="anlagenteilNamenZuruecksetzen()">
              <mat-icon>undo</mat-icon>
              Klartexte verwerfen
            </button>
          </div>

          <p class="anlagenteil-werte-hinweis">
            Der Anzeigename ist optional. Ohne Eingabe bleibt der Excel-Wert der
            Name des Anlagenteils; der Originalwert der Datei wird in keinem Fall
            verändert.
          </p>

          <table class="anlagenteil-werte-tabelle">
            <thead>
              <tr>
                <th>Excel-Wert</th>
                <th>Anzeigen als</th>
                <th class="anlagenteil-werte-zahl">Zeilen</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let w of anlagenteilWerte">

                <td data-label="Excel-Wert">
                  <span class="anlagenteil-rohwert">{{ w.wert }}</span>
                </td>

                <td data-label="Anzeigen als">
                  <mat-form-field appearance="outline" class="anlagenteil-name-feld">
                    <input matInput [ngModel]="anlagenteilAnzeigename(w.wert)"
                      (ngModelChange)="setAnlagenteilAnzeigename(w.wert, $event)" [placeholder]="w.wert">
                    <!--
                      Kam die Benennung aus einer früheren Inbetriebnahme
                      desselben Projekts, wird das gesagt – der Benutzer soll
                      wissen, warum da schon etwas steht.
                    -->
                    <mat-hint *ngIf="w.ausProjekt">
                      aus diesem Projekt übernommen
                    </mat-hint>
                  </mat-form-field>
                </td>

                <td class="anlagenteil-werte-zahl" data-label="Zeilen">
                  {{ w.anzahl }}
                </td>

              </tr>
            </tbody>
          </table>
        </div>

        <!-- Regeln -->
        <div class="regel-block" *ngFor="let regel of anlagenteilRegeln; let i = index">
          <div class="regel-zeile">
            <mat-form-field appearance="outline" class="regel-feld">
              <mat-label>Feld</mat-label>
              <mat-select [(ngModel)]="regel.feld" (selectionChange)="vorschauAktualisieren()">
                <mat-option *ngFor="let f of regelFelder" [value]="f">
                  {{ regelFeldAnzeige(f) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="regel-operator">
              <mat-label>Bedingung</mat-label>
              <mat-select [(ngModel)]="regel.operator" (selectionChange)="vorschauAktualisieren()">
                <mat-option *ngFor="let o of operatoren" [value]="o.wert">{{ o.text }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="regel-wert">
              <mat-label>Wert</mat-label>
              <input matInput [(ngModel)]="regel.wert" (ngModelChange)="vorschauAktualisieren()"
                placeholder="z.B. 11NDA">
            </mat-form-field>

            <mat-form-field appearance="outline" class="regel-wert">
              <mat-label>Anlagenteil</mat-label>
              <input matInput [(ngModel)]="regel.anlagenteilName" (ngModelChange)="vorschauAktualisieren()"
                placeholder="z.B. Absackung">
            </mat-form-field>

            <span class="regel-treffer" *ngIf="regel.treffer !== null">
              {{ regel.treffer }} Treffer
            </span>

            <button mat-icon-button type="button" (click)="anlagenteilRegelEntfernen(i)" matTooltip="Regel entfernen">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <button mat-button type="button" (click)="anlagenteilRegelHinzufuegen()">
          <mat-icon>add</mat-icon>
          Anlagenteil-Regel hinzufügen
        </button>
      </div>

    </mat-card-content>
  </mat-card>


  <!-- =================================================================
       KATEGORIEN – KOMPAKT

       Die Regeln arbeiten auf STANDARDFELDERN, nicht auf Excel-Spalten:
       ob die Datei „Bezeichnung“, „Beschriftung“ oder „Description“
       schreibt, ist gleichgültig – was als „Langtext“ erkannt wurde, ist
       hier der Langtext. Auch dann, wenn die Spalte vom Import
       ausgeschlossen ist: gerechnet wird beim Import auf der vollständigen
       Datei, gespeichert nur die Auswahl.
       ================================================================= -->

  <mat-card class="step-card" *ngIf="analysis && kategorien.length > 0" data-wizard-target="import-kategorien">
    <mat-card-content>

      <div class="step-head">
        <span class="step-number">4</span>
        <span class="step-title">Kategorien</span>

        <button mat-stroked-button type="button" class="kopf-aktion" (click)="kategorienBearbeitenUmschalten()">
          <mat-icon>{{ kategorienBearbeiten ? 'expand_less' : 'tune' }}</mat-icon>
          {{ kategorienBearbeiten ? 'Prüfung schließen' : 'Zuordnungen prüfen' }}
        </button>
      </div>

      <p class="kompakt-zeile">
        <ng-container *ngIf="aktiveKategorieRegelnAnzahl > 0">
          <mat-icon class="haken">check</mat-icon>
          <span>
            {{ aktiveKategorieRegelnAnzahl }}
            Regel{{ aktiveKategorieRegelnAnzahl === 1 ? '' : 'n' }} aktiv
            · {{ zeilenMitKategorie }} Zeilen bekommen eine Kategorie
          </span>
        </ng-container>

        <ng-container *ngIf="aktiveKategorieRegelnAnzahl === 0">
          <mat-icon class="haken haken-leer">remove</mat-icon>
          <span>
            Keine Kategorieregel aktiv. Kategorien lassen sich auch später
            an der Liste vergeben.
          </span>
        </ng-container>
      </p>


      <div class="kompakt-inhalt" *ngIf="kategorienBearbeiten">

        <p class="step-hint">
          Die Kategorie bestimmt die Prüfpunkte einer Messstelle. Die Regel prüft
          den WERT eines Standardfelds – „Kennzeichnung enthält CT“ ordnet alle
          Temperaturfühler auf einmal ein. Vorschläge der Erkennung stehen bereits
          als Regel bereit.
        </p>

        <div class="regel-block" *ngFor="let regel of kategorieRegeln; let i = index">
          <div class="regel-zeile">
            <mat-form-field appearance="outline" class="regel-feld">
              <mat-label>Feld</mat-label>
              <mat-select [(ngModel)]="regel.feld" (selectionChange)="vorschauAktualisieren()">
                <mat-option *ngFor="let f of regelFelder" [value]="f">
                  {{ regelFeldAnzeige(f) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="regel-operator">
              <mat-label>Bedingung</mat-label>
              <mat-select [(ngModel)]="regel.operator" (selectionChange)="vorschauAktualisieren()">
                <mat-option *ngFor="let o of operatoren" [value]="o.wert">{{ o.text }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="regel-wert">
              <mat-label>Wert</mat-label>
              <input matInput [(ngModel)]="regel.wert" (ngModelChange)="vorschauAktualisieren()" placeholder="z.B. CT">
            </mat-form-field>

            <app-kategorie-auswahl class="regel-feld"
              [kategorien]="kategorien" leerText="— wählen —"
              [(ngModel)]="regel.kategorieId" (valueChange)="vorschauAktualisieren()">
            </app-kategorie-auswahl>

            <span class="regel-treffer" *ngIf="regel.treffer !== null">
              {{ regel.treffer }} Treffer
            </span>

            <button mat-icon-button type="button" (click)="kategorieRegelEntfernen(i)" matTooltip="Regel entfernen">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <button mat-button type="button" (click)="kategorieRegelHinzufuegen()">
          <mat-icon>add</mat-icon>
          Kategorie-Regel hinzufügen
        </button>
      </div>

    </mat-card-content>
  </mat-card>


  <!-- =================================================================
       DIE VORSCHAU – DER HAUPTTEIL

       So sieht die Liste nach dem Import aus. Gerechnet serverseitig mit
       derselben Logik wie der Import – gespeichert wird dabei nichts.

       Eine Tabelle, zwei Zustände: im Ansehen reine Anzeige ohne
       Häkchen, im Bearbeiten mit Häkchen, Filter und Suche. Es gibt
       keine zweite Tabelle, die auseinanderlaufen könnte.
       ================================================================= -->

  <mat-card class="step-card vorschau-card" *ngIf="preview" data-wizard-target="import-vorschau">
    <mat-card-content>

      <div class="step-head">
        <span class="step-number">
          <mat-icon class="step-icon">visibility</mat-icon>
        </span>
        <span class="step-title">So wird die Liste aussehen</span>

        <mat-spinner diameter="20" *ngIf="vorschauLaeuft"></mat-spinner>
        <span class="veraltet-hinweis" *ngIf="vorschauVeraltet && !vorschauLaeuft">
          wird aktualisiert …
        </span>
      </div>

      <div class="regel-fehler" *ngIf="vorschauFehler">
        <mat-icon inline>error_outline</mat-icon> {{ vorschauFehler }}
      </div>

      <ng-container *ngIf="vorschau as v">

        <!--
          Die Zähler kommen aus DEMSELBEN Zustand wie die Tabelle darunter
          und der Import. Eine zweite Zählung wäre die erste, die falsch
          steht.
        -->
        <div class="ai-summary">
          <span class="summary-chip">{{ zeilenGesamt }} Zeilen erkannt</span>
          <span class="summary-chip chip-import">{{ zeilenImport }} werden importiert</span>
          <span class="summary-chip chip-aus" *ngIf="zeilenAus > 0">
            {{ zeilenAus }} ausgeschlossen
          </span>
          <span class="summary-chip chip-warn" *ngIf="zeilenUnsicher > 0">
            {{ zeilenUnsicher }} unsicher
          </span>
          <span class="summary-chip">{{ vorschauSpalten.length }} Spalten importieren</span>
          <span class="summary-chip chip-aus" *ngIf="ausgeschlosseneSpalten > 0">
            {{ ausgeschlosseneSpalten }} Spalten ausgeschlossen
          </span>
          <span class="summary-chip" *ngIf="v.mitKategorie > 0">
            {{ v.mitKategorie }} mit Kategorie
          </span>
          <span class="summary-chip" *ngIf="v.mitAnlagenteil > 0">
            {{ v.mitAnlagenteil }} mit Anlagenteil
          </span>

          <mat-spinner diameter="18" *ngIf="relevanzLaeuft"></mat-spinner>
          <span class="veraltet-hinweis" *ngIf="relevanzLaeuft">
            Zeilen werden geprüft …
          </span>
        </div>

        <div class="ai-warnungen" *ngIf="v.warnungen.length > 0">
          <div class="warnung-zeile" *ngFor="let w of v.warnungen">
            <mat-icon inline>report_problem</mat-icon>
            <span>{{ w }}</span>
          </div>
        </div>

        <div class="abgleich-warnung" *ngIf="relevanzFehler">
          <mat-icon inline>error_outline</mat-icon> {{ relevanzFehler }}
        </div>


        <!-- Die beiden Korrekturwege. Mehr braucht der normale Import nicht. -->
        <div class="vorschau-aktionen">
          <button mat-stroked-button type="button"
            [attr.data-wizard-target]="spaltenPanelOffen ? null : 'import-spalten'" *ngIf="analysis"
            [class.aktion-aktiv]="spaltenPanelOffen" (click)="spaltenPanelUmschalten()">

            <mat-icon>view_column</mat-icon>
            Spalten anpassen

          </button>

          <button mat-stroked-button type="button"
            [attr.data-wizard-target]="zeilenBearbeitung ? null : 'import-zeilen'" *ngIf="relevanz"
            [class.aktion-aktiv]="zeilenBearbeitung" (click)="zeilenBearbeitungUmschalten()">
            <mat-icon>{{ zeilenBearbeitung ? 'check' : 'rule' }}</mat-icon>
            {{ zeilenBearbeitung ? 'Bearbeitung beenden' : 'Zeilenauswahl bearbeiten' }}
          </button>

          <span class="vorschau-hinweis" *ngIf="!zeilenBearbeitung && zeilenUnsicher > 0">
            {{ zeilenUnsicher }} Zeile{{ zeilenUnsicher === 1 ? '' : 'n' }}
            konnte{{ zeilenUnsicher === 1 ? '' : 'n' }} nicht sicher eingeordnet
            werden und {{ zeilenUnsicher === 1 ? 'wird' : 'werden' }} nicht importiert.
          </span>
        </div>


        <!-- ── Spalten anpassen ── -->

        <div class="spalten-panel" *ngIf="spaltenPanelOffen && analysis" data-wizard-target="import-spalten">

          <div class="spalten-panel-kopf">
            <span class="spalten-panel-titel">Spalten anpassen</span>

            <button mat-icon-button type="button" matTooltip="Schließen" (click)="spaltenPanelUmschalten()">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <p class="step-hint">
            Hier stehen ALLE {{ importierteSpalten }} Spalten des Blatts, auch
            die ohne erkanntes Standardfeld. Das Häkchen entscheidet
            endgültig: eine abgewählte Spalte wird <strong>nicht
              gespeichert</strong> – ihre Werte fehlen danach in der Liste, auf
            der Detailseite und beim Abgleich.
          </p>

          <p class="step-hint">
            Die automatische Erkennung ist zu diesem Zeitpunkt bereits
            gelaufen und hat alle Spalten gesehen. Kategorie- und
            Anlagenteilregeln rechnen beim Import ebenfalls noch auf der
            vollständigen Datei: eine Regel auf „Langtext“ greift auch dann,
            wenn die Spalte, die den Langtext trägt, abgewählt ist.
          </p>

          <div class="spalten-warnung" *ngIf="keineSpalteGewaehlt">
            <mat-icon inline>report_problem</mat-icon>
            <span>
              Es ist keine einzige Spalte ausgewählt. So lässt sich nichts
              importieren – bitte mindestens eine anhaken.
            </span>
          </div>

          <div class="spalten-panel-leiste">
            <mat-form-field appearance="outline" class="spalten-suche">
              <mat-label>Spalte suchen</mat-label>
              <input matInput [(ngModel)]="spaltenSuche" placeholder="Name oder Standardfeld">
              <button mat-icon-button matSuffix type="button" *ngIf="spaltenSuche" (click)="spaltenSuche = ''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <span class="spalten-treffer">
              {{ spaltenAuswahl.length }} von {{ importierteSpalten }}
              · {{ gewaehlteSpalten }} werden importiert
            </span>

            <button mat-button type="button" (click)="spaltenAuswahlSetzen(true)">
              <mat-icon>done_all</mat-icon>
              Angezeigte importieren
            </button>

            <button mat-button type="button" (click)="spaltenAuswahlSetzen(false)">
              <mat-icon>remove_done</mat-icon>
              Angezeigte ausschließen
            </button>

            <button mat-button type="button" (click)="spaltenVorschlagWiederherstellen()">
              <mat-icon>auto_awesome</mat-icon>
              Vorschlag wiederherstellen
            </button>
          </div>

          <div class="table-scroll spalten-liste">
            <table class="spalten-table">
              <thead>
                <tr>
                  <th>Excel-Spalte</th>
                  <th>Erkannt als</th>
                  <th class="spalten-check">Importieren</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let spalte of spaltenAuswahl; trackBy: trackBySpalte"
                  [class.zeile-ignoriert]="!spalte.isIncluded" [class.zeile-unsicher]="istUnsicher(spalte)">

                  <td class="col-name" data-label="Excel-Spalte">
                    <span class="spalten-name" [matTooltip]="spalte.originalName">
                      {{ spalte.originalName }}
                    </span>
                    <span class="spalten-conf" *ngIf="istUnsicher(spalte)"
                      matTooltip="Geringe Sicherheit – bitte prüfen">
                      nur {{ confidenceProzent(spalte) }} % sicher
                    </span>
                  </td>

                  <td data-label="Erkannt als">
                    <mat-form-field appearance="outline" class="zellen-feld">
                      <mat-select [ngModel]="spalte.mappedField" (ngModelChange)="spalteFeldSetzen(spalte, $event)">
                        <mat-option [value]="null">–</mat-option>
                        <!--
                          Fremde Felder stehen mit in der Liste, damit eine
                          Zuordnung nie unbemerkt verschwindet.
                        -->
                        <mat-option *ngFor="let f of standardFelder" [value]="f">
                          {{ feldAnzeige(f) }}
                          <span class="fremd-hinweis" *ngIf="istFremdesFeld(f)">· nicht im Katalog</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>

                  <td class="spalten-check" data-label="Importieren">
                    <mat-checkbox [checked]="spalte.isIncluded" (change)="spalteImportSetzen(spalte, $event.checked)">
                    </mat-checkbox>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>


        <!-- ── Zeilenauswahl bearbeiten: Leiste über derselben Tabelle ── -->

        <div class="wizard-zeilen-bereich" [attr.data-wizard-target]="zeilenBearbeitung ? 'import-zeilen' : null">
          <div class="zeilen-leiste" *ngIf="zeilenBearbeitung && relevanz as r">

            <mat-button-toggle-group [(ngModel)]="relevanzFilter" (change)="zeilenFilterGeaendert()">
              <mat-button-toggle value="alle">Alle</mat-button-toggle>
              <mat-button-toggle value="import">Importieren</mat-button-toggle>
              <mat-button-toggle value="aus">Ausgeschlossen</mat-button-toggle>
              <mat-button-toggle value="unsicher">Unsicher</mat-button-toggle>
            </mat-button-toggle-group>

            <mat-form-field appearance="outline" class="relevanz-suche">
              <mat-label>Suchen</mat-label>
              <input matInput [(ngModel)]="relevanzSuche" (ngModelChange)="zeilenFilterGeaendert()"
                placeholder="Kennzeichnung, Inhalt, Grund">
              <button mat-icon-button matSuffix type="button" *ngIf="relevanzSuche"
                (click)="relevanzSuche = ''; zeilenFilterGeaendert()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <span class="relevanz-treffer">
              {{ gefilterteAnzahl }} von {{ r.gesamt }}
            </span>

            <button mat-button type="button" (click)="gefilterteUmschalten(true)">
              <mat-icon>done_all</mat-icon>
              Angezeigte importieren
            </button>

            <button mat-button type="button" (click)="gefilterteUmschalten(false)">
              <mat-icon>remove_done</mat-icon>
              Angezeigte ausschließen
            </button>

            <button mat-stroked-button color="primary" type="button" [disabled]="relevanzLaeuft"
              matTooltip="Von Hand gesetzte Zeilen bleiben dabei unangetastet." (click)="zeilenPruefen(true)">
              <mat-spinner diameter="18" *ngIf="relevanzLaeuft"></mat-spinner>
              <ng-container *ngIf="!relevanzLaeuft">
                <mat-icon>refresh</mat-icon>
                Erneut prüfen
              </ng-container>
            </button>

            <button mat-button type="button" (click)="zeilenBearbeitungUmschalten()">
              <mat-icon>check</mat-icon>
              Bearbeitung beenden
            </button>
          </div>

          <!--
          Was der Durchlauf gekostet hat. Steht bewusst da: die Prüfung ist
          der einzige Schritt des Imports, der Geld kostet.
        -->
          <p class="relevanz-kosten" *ngIf="zeilenBearbeitung && relevanz as r">
            <mat-icon inline>bolt</mat-icon>
            {{ r.ohneKi }} von {{ r.gesamt }} Zeilen ohne KI entschieden
            <ng-container *ngIf="r.kiZeilen > 0">
              · {{ r.kiZeilen }} verschiedene Zeilen in {{ r.kiAnfragen }}
              Anfrage{{ r.kiAnfragen === 1 ? '' : 'n' }} geprüft
            </ng-container>
            <ng-container *ngIf="r.merkmalsspalten.length > 0">
              · beurteilt nach: {{ r.merkmalsspalten.join(', ') }}
            </ng-container>
            <ng-container *ngIf="r.kiMeldung"> · {{ r.kiMeldung }}</ng-container>
          </p>


          <!-- ── DIE Tabelle ── -->

          <div class="table-scroll vorschau-scroll">
            <table class="vorschau-table" [class.tabelle-bearbeiten]="zeilenBearbeitung">
              <thead>
                <tr>
                  <th class="relevanz-check" *ngIf="zeilenBearbeitung">Import</th>
                  <th class="status-col" *ngIf="!zeilenBearbeitung">Status</th>
                  <th class="row-col">Zeile</th>
                  <th *ngIf="v.mitAnlagenteil > 0">Anlagenteil</th>
                  <th *ngIf="v.mitKategorie > 0">Kategorie</th>
                  <th *ngFor="let s of vorschauSpalten">
                    <span class="spalten-kopf">
                      <span class="spalten-kopf-feld">{{ s.anzeige }}</span>
                      <span class="spalten-kopf-original" *ngIf="s.herkunft">{{ s.herkunft }}</span>
                    </span>
                  </th>
                  <th *ngIf="zeilenBearbeitung">Beurteilung</th>
                </tr>
              </thead>
              <tbody>
                <!--
                Ausgeschlossene Zeilen bleiben stehen, nur blass: der Benutzer
                muss sehen können, was NICHT importiert wird. Unsichere sind
                hervorgehoben, weil genau sie eine Entscheidung brauchen.
              -->
                <tr *ngFor="let z of anzeigeZeilen; trackBy: trackByAnzeigeZeile"
                  [class.zeile-ausgeschlossen]="zeileIstAusgeschlossen(z)" [class.zeile-unsicher]="zeileIstUnsicher(z)">

                  <td class="relevanz-check" data-label="Import" *ngIf="zeilenBearbeitung">
                    <mat-checkbox [checked]="wirdImportiert(z)" [disabled]="!z.status"
                      (change)="zeileUmschalten(z, $event.checked)">
                    </mat-checkbox>
                  </td>

                  <td class="status-col" *ngIf="!zeilenBearbeitung" [matTooltip]="statusHinweis(z)">
                    <mat-icon class="status-icon status-icon-import"
                      *ngIf="istEingeschlossen(z) && !zeileIstUnsicher(z)">
                      check
                    </mat-icon>
                    <mat-icon class="status-icon status-icon-aus" *ngIf="zeileIstAusgeschlossen(z)">
                      remove
                    </mat-icon>
                    <mat-icon class="status-icon status-icon-unsicher" *ngIf="zeileIstUnsicher(z)">
                      help_outline
                    </mat-icon>
                  </td>

                  <td class="row-col">{{ z.rowNumber }}</td>

                  <td *ngIf="v.mitAnlagenteil > 0">
                    <span class="zuordnung-chip chip-anlagenteil" *ngIf="z.anlagenteilName">
                      {{ z.anlagenteilName }}
                    </span>
                    <!--
                    Der Excel-Wert klein daneben, sobald ein Klartext gilt.
                    Er ist nicht verschwunden – er steht weiter in der Zeile.
                  -->
                    <span class="chip-herkunft" *ngIf="z.anlagenteilName && rohwertZuZeile(z) as roh">
                      {{ roh }}
                    </span>
                    <span class="ohne-zuordnung" *ngIf="!z.anlagenteilName">–––</span>
                  </td>

                  <td *ngIf="v.mitKategorie > 0">
                    <span class="zuordnung-chip chip-kategorie" *ngIf="z.kategorieName">
                      {{ z.kategorieName }}
                    </span>
                    <span class="ohne-zuordnung" *ngIf="!z.kategorieName">–––</span>
                  </td>

                  <td *ngFor="let s of vorschauSpalten" [matTooltip]="z.werte[s.name] || ''">
                    {{ z.werte[s.name] }}
                  </td>

                  <td data-label="Beurteilung" *ngIf="zeilenBearbeitung">
                    <ng-container *ngIf="z.status as st">
                      <span class="relevanz-badge" [class.badge-import]="st.relevanz === 'Relevant'"
                        [class.badge-aus]="st.relevanz === 'Irrelevant'"
                        [class.badge-unsicher]="st.relevanz === 'Unsicher'">
                        {{ relevanzText(st) }}
                      </span>
                      <span class="relevanz-grund" *ngIf="st.grund">{{ st.grund }}</span>
                      <span class="relevanz-quelle">{{ quelleText(st) }}</span>
                    </ng-container>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

          <div class="vorschau-fuss">
            <button mat-button type="button" *ngIf="weitereVorschauZeilen > 0" (click)="mehrVorschauZeilenZeigen()">
              <mat-icon>expand_more</mat-icon>
              Weitere {{ weitereVorschauZeilen }} Zeilen anzeigen
            </button>

            <!--
            Sehr grosse Dateien deckelt die Vorschau. Entschieden werden kann
            über diese Zeilen trotzdem: im Bearbeitungsmodus arbeitet dieselbe
            Tabelle auf der Beurteilung, und die deckt jede Zeile ab.
            -->
            <span class="vorschau-hinweis" *ngIf="nichtGezeigteZeilen > 0 && !zeilenBearbeitung">
              {{ v.zeilen.length }} von {{ v.zeilenGesamt }} Zeilen tragen hier
              volle Werte – über die übrigen {{ nichtGezeigteZeilen }} lässt sich
              unter „Zeilenauswahl bearbeiten“ trotzdem entscheiden.
            </span>

            <span class="vorschau-hinweis" *ngIf="ausgeschlosseneSpalten > 0">
              {{ ausgeschlosseneSpalten }} Spalten sind ausgeschlossen und werden
              nicht importiert – nachzusehen unter „Spalten anpassen“.
            </span>
          </div>
        </div>

      </ng-container>
    </mat-card-content>
  </mat-card>


  <!-- Letzter Schritt: benennen und endgültig importieren -->
  <mat-card class="step-card" *ngIf="preview" data-wizard-target="import-abschluss">
    <mat-card-content>
      <div class="step-head">
        <span class="step-number">
          <mat-icon class="step-icon">save</mat-icon>
        </span>
        <span class="step-title">Benennen</span>
      </div>

      <!--
        Was der Import tatsächlich anlegen wird. Steht hier, weil es die
        letzte Gelegenheit ist, es zu bemerken.
      -->
      <div class="import-umfang" *ngIf="relevanz">
        <mat-icon inline>rule</mat-icon>
        <span>
          Es werden <strong>{{ zeilenImport }}</strong> von
          {{ zeilenGesamt }} Zeilen importiert;
          {{ zeilenAus }} bleiben ausgeschlossen.
          <ng-container *ngIf="zeilenUnsicher > 0">
            {{ zeilenUnsicher }} unsichere Zeilen werden NICHT importiert –
            sie stehen oben unter „Zeilenauswahl bearbeiten“ zum Anhaken.
          </ng-container>
          <ng-container *ngIf="analysis">
            Gespeichert werden <strong>{{ gewaehlteSpalten }}</strong> von
            {{ importierteSpalten }} Excel-Spalten<ng-container *ngIf="ausgeschlosseneSpalten > 0">; die übrigen
              {{ ausgeschlosseneSpalten }} bleiben in der Datei und werden
              nicht übernommen</ng-container>.
          </ng-container>
        </span>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>Name der Liste</mat-label>
          <input matInput [(ngModel)]="listenName" placeholder="z.B. Messstellen Objekt Süd">
        </mat-form-field>

        <!--
          Aus einem Projekt heraus ist der Kunde festgelegt (er kommt vom Projekt),
          deshalb wird die Auswahl dann durch einen Hinweis ersetzt.
        -->
        <mat-form-field appearance="outline" *ngIf="!projektId">
          <mat-label>Kunde (optional)</mat-label>
          <mat-select [(ngModel)]="customerId">
            <mat-option [value]="null">— keiner —</mat-option>
            <mat-option *ngFor="let c of customers" [value]="c.id">{{ c.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        
      </div>

      


      <div class="actions" *ngIf="!eingebettet">
        <button mat-raised-button color="primary" [disabled]="!canImport" (click)="startImport()">

          <mat-icon>save</mat-icon>
          Jetzt importieren
        </button>

        <mat-spinner diameter="24" *ngIf="isImporting">
        </mat-spinner>

        <button mat-button (click)="cancel()" [disabled]="isImporting">
          Abbrechen
        </button>
      </div>

      

    </mat-card-content>
  </mat-card>
</div>